import React, { Fragment, Component } from "react";
import {
  List,
  Datagrid,
  ReferenceField,
  TextField,
  DateField
} from "react-admin";
import { DoctorReferenceField } from "../../misc/customFields";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Route } from "react-router";
import Drawer from "@material-ui/core/Drawer";
import MainAuditDetail from "./MainAuditDetail";
import { MainAuditFilter } from "./filters";

class MainAuditList extends Component {
  render() {
    const { props } = this;
    return (
      <Fragment>
        <List {...props} bulkActionButtons={null} filters={<MainAuditFilter />}>
          <Datagrid rowClick="show">
            <TextField source="id" />
            <TextField source="entity" label="Entity Type" />
            <TextField source="db_id" label="Entity ID" />
            <TextField source="operation" />
            <DoctorReferenceField label="Clinician" allowEmpty />
            <DateField source="created" showTime />
          </Datagrid>
        </List>
        <Route path="/main_audit/:id">
          {({ match }) => {
            const isMatch =
              match && match.params && match.params.id !== "create";
            return (
              <Drawer
                variant="persistent"
                open={isMatch}
                anchor="right"
                onClose={this.handleClose}
              >
                {isMatch ? (
                  <MainAuditDetail
                    id={match.params.id}
                    onCancel={this.handleClose}
                    {...props}
                  />
                ) : null}
              </Drawer>
            );
          }}
        </Route>
      </Fragment>
    );
  }

  handleClose = () => {
    this.props.push("/main_audit");
  };
}

export default connect(
  undefined,
  { push }
)(MainAuditList);
